<template>
  <div class="body-custom-item" style="margin-top: 112px;">
    <div class="item-title">
      Change order message
    </div>
    <div class="item-subtitle">
      You are requesting to change <span class="blue">(Event name here)</span> after it’s been approved.
    </div>
    <div class="item-body-detail">
      <vue-editor id="change-order-message" v-model="message"
                  :class="isDefault ? 'default-message' : null"></vue-editor>
    </div>
    <div class="grp-button-action">
      <b-button class="item-reset-btn" @click="resetMessage()">
        <span class="dt-group-btn-func-btn-left-text">RESET MESSAGE</span>
      </b-button>
      <b-button class="item-save-btn dt-group-btn-func-btn-right" @click="saveMessage('CHANGE_ORDER')"
                :disabled="!canSave">
        <Icon name="file-text-o"></Icon>
        <span class="dt-group-btn-func-btn-left-text">SAVE MESSAGE</span>
      </b-button>
      <b-button class="item-cancel-btn" @click="hideModal()">
        <span class="dt-group-btn-func-btn-left-text">CANCEL</span>
      </b-button>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/file-text-o';
  import {VueEditor} from 'vue2-editor';
  import Icon from 'vue-awesome/components/Icon';
  import constant from '../../_consts';

  export default {
    name: '',
    components: {
      Icon,
      VueEditor
    },
    data () {
      return {
        canSave: true,
        message: '',
        isDefault: true
      }
    },
    props: {
      content: {
        type: String,
        default: ''
      }
    },
    methods: {
      saveMessage (type) {
        this.$emit('UPDATE_MESSAGE', {
          type: type,
          content: this.message
        });
      },
      hideModal () {
        this.$modal.hide('customMessageModal');
      },
      resetMessage () {
        this.message = constant.defaultModalMessage.changeOrderMessage;
        this.saveMessage('CHANGE_ORDER');
      }
    },
    computed: {},
    mounted () {
      this.message = this.content;
    },
    watch: {
      message: {
        handler: function () {
          if (this.message === '<p><br></p>') {
            this.canSave = false;
          }
          if (this.message === constant.defaultModalMessage.changeOrderMessage) {
            this.isDefault = true;
          } else {
            this.isDefault = false;
          }
        }
      }
    }
  }
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// CustomMessageSectionChangeOrder.vue?a4334298